import { jwtDecode } from "jwt-decode";

export const getSessionUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  try {
    const decoded = jwtDecode(token);
    return {
      role: decoded.role,
      accesses: decoded.accesses || [],
      permissions: decoded.permissions || [],
    };
  } catch {
    return {};
  }
};